import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  HttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const httpLink = new HttpLink({
  uri: "https://api-ap-south-1.graphcms.com/v2/ckxsifeft1xro01z371c356qw/master",
  useGETForQueries: true,
});

const authLink = setContext((_, { headers }) => {
  const token =
    "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2NDA4NTQ1NzAsImF1ZCI6WyJodHRwczovL2FwaS1hcC1zb3V0aC0xLmdyYXBoY21zLmNvbS92Mi9ja3hzaWZlZnQxeHJvMDF6MzcxYzM1NnF3L21hc3RlciIsImh0dHBzOi8vbWFuYWdlbWVudC1uZXh0LmdyYXBoY21zLmNvbSJdLCJpc3MiOiJodHRwczovL21hbmFnZW1lbnQuZ3JhcGhjbXMuY29tLyIsInN1YiI6IjI0NzFlZmU1LTAwZTgtNDViYS1hOTE3LWEzMzU4YmVjOGQxYSIsImp0aSI6ImNreHNxZzF2NTIzMGQwMXo5NmVnaTBhNGkifQ.qW0CCj6iMhCQGj-d2HNK37-8rkWCbGD3yeSGluoU3itcSV46fL4H3PrR3SfKm_bwdtCwgv2NM_WczRW7gvZkhAH7-NV00oQigjn9PJjfEbR9IdnE9n2cw8Ksnyb5D4rxxxiKeEIwmRdssWqehFvHEJ5qfmuXF20RJPMU0qY8mun9ldUJx_1pytdgAh2yXz6J2_HpiYYHM4Tzsil1yw3hwHuBPp5q6R2cac9DPL8jSbcpMCYXptVkpBlbrpdjC8wYM2RxBMSEOYJo8ZYA5nXH0OTHn-W67hFWVq5r5hbUixK6x12ib3bSesXw4KPDKiXCzSa7K0F-1gHh7atHycrdzXloYz_BqnD0nAgR63zWk_KqgYGmeotlU-QoTJ2MxjIbUNGpwIEJ2FRBSILpr10L0k9sO7Qw_USBD_lipzVlEnet_ZTx_eOJhoIua-9VP7OiSA3YWbw4bAlscziFPsBX4ZxyiWV6IzrN5VznU8vejaKEhvLh7JV8xl8-zr7urq7uAOVjuP8e2d_3QKd5nCAnuzMUm6XnlGKp_Qf43otCvTMJZlyJXh5TaN-kVUw5ScO6oFRI6S0JtK9E8Q3oGi6i2pmqnRfB1jro-pQ9A0xUKOD-nUy0lMeh3O9BzCfDCg9-YAPmpYnAHiD7fbLw0SoRi9Ezm17aSDd60yIjXmkVC7M";
  return {
    headers: {
      ...headers,
      // Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ToastContainer />
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
